module.exports = __webpack_public_path__ + "img/useSlide04.250e326f.jpg";